__turbopack_context__.v({
  "arrow": "ProgramsList-module-scss-module__nquFMq__arrow",
  "bankIcon": "ProgramsList-module-scss-module__nquFMq__bankIcon",
  "bankProgram": "ProgramsList-module-scss-module__nquFMq__bankProgram",
  "bankProgramCta": "ProgramsList-module-scss-module__nquFMq__bankProgramCta",
  "clean": "ProgramsList-module-scss-module__nquFMq__clean",
  "compare": "ProgramsList-module-scss-module__nquFMq__compare",
  "comparingsBtns": "ProgramsList-module-scss-module__nquFMq__comparingsBtns",
  "content": "ProgramsList-module-scss-module__nquFMq__content",
  "credit": "ProgramsList-module-scss-module__nquFMq__credit",
  "cta": "ProgramsList-module-scss-module__nquFMq__cta",
  "emptyList": "ProgramsList-module-scss-module__nquFMq__emptyList",
  "list": "ProgramsList-module-scss-module__nquFMq__list",
  "loading": "ProgramsList-module-scss-module__nquFMq__loading",
  "payment": "ProgramsList-module-scss-module__nquFMq__payment",
  "program": "ProgramsList-module-scss-module__nquFMq__program",
  "rate": "ProgramsList-module-scss-module__nquFMq__rate",
  "show": "ProgramsList-module-scss-module__nquFMq__show",
  "summary": "ProgramsList-module-scss-module__nquFMq__summary",
  "title": "ProgramsList-module-scss-module__nquFMq__title",
  "wrapper": "ProgramsList-module-scss-module__nquFMq__wrapper",
});
